import React, { Component } from "react";
import { connect } from "react-redux";
import ListItem from "@material-ui/core/ListItem";
import "./ListItem.css";
import { Link } from "react-router-dom";
import { setProduct } from "../../store/actions";
import { ReactComponent as Clock } from "./assets/alarm-clock.svg";
import Highlighter from "react-highlight-words";

import ReactPixel from "@bettercart/react-facebook-pixel";
import SnapchatPixel from "react-snapchat-pixel";
import ReactGA from "react-ga4";
import TiktokPixel from "../../tiktok-pixel";
import TwitterPixel from "../../TwitterPixel";
import { GTM } from "../../App";
import QuickAddToCart from "./QuickAddToCart";
import OutOfStock from "./OutOfStock";
import NotAvailable from "./NotAvailable";
import {
  isOutOfStock,
  getPrepTime,
  getOriginalProduct,
  checkForStockWarningMessage,
} from "./Helpers";
import { getNewPrice, getDiscountedPercentage } from "../../Helpers/promotions";
import dairyFreeIcon from "../ActionButton/assests/no-milk.png";
import glutenFreeIcon from "../ActionButton/assests/gluten-free.png";
import sugarFreeIcon from "../ActionButton/assests/sugar-free.png";
import nutFreeIcon from "../ActionButton/assests/peanut-free.png";
import organicIcon from "../ActionButton/assests/bio_480.png";
import vegetarianIcon from "../ActionButton/assests/leaf.png";
import veganIcon from "../ActionButton/assests/vegan.png";
import glutenIcon from "../ActionButton/assests/gluten.png";
import nutsSesameIcon from "../ActionButton/assests/nuts_sesame.png";
import dairyIcon from "../ActionButton/assests/dairy.png";
import eggIcon from "../ActionButton/assests/egg.png";
import seafoodShellfishIcon from "../ActionButton/assests/seafood_shellfish.png";
import chilliIcon from "../ActionButton/assests/chilli.png";
import ProductTag from "../ProductDetails/ProductTag";
import { getCurrencyIcon } from "../../Helpers/currencyConverter";
class Item extends Component {
  state = { isSelected: false };
  analytics = () => {
    const { settings } = this.props;

    if (this.props.settings.enable_fb_pixel && this.props.settings.fb_pixel) {
      ReactPixel.track("Search", {
        content_category: this.props.product.category,
        content_ids: [this.props.product.id.toString()],
        currency: settings.currency_iso,
        search_string: this.props.filter_value,
        value: this.props.product.price,
      });
    }
    if (
      this.props.settings.enable_google_analytics &&
      this.props.settings.google_analytics
    ) {
      ReactGA.event({
        category: "Search",
        action: `User Searched for ${this.props.product.name} Using the String ${this.props.filter_value}`,
        label: "Search",
      });
    }

    if (
      this.props.settings.enable_snap_pixel &&
      this.props.settings.snap_pixel
    ) {
      SnapchatPixel.track("SEARCH", {
        currency: settings.currency_iso,
        price: this.props.product.price,
        item_category: this.props.product.category,
        item_ids: [this.props.product.id],
        search_string: this.props.filter_value,
        integration: "ordable",
      });
    }
    if (GTM) {
      GTM.track("search", {
        content_category: this.props.product.category,
        content_ids: this.props.product.id,
        currency: settings.currency_iso,
        search_string: this.props.filter_value,
        value: this.props.product.price,
      });
    }
    if (
      this.props.settings.enable_tiktok_pixel &&
      this.props.settings.tiktok_pixel
    ) {
      TiktokPixel.track("Search", {
        content_id: this.props.product.id.toString(),
        content_type: "product",
        query: this.props.filter_value,
      });
    }
    if (TwitterPixel.isInitialized()) {
      if (this.props.settings.twitter_events["Search"]) {
        TwitterPixel.track(this.props.settings.twitter_events["Search"], {
          search_string: this.props.filter_value,
          contents: [
            {
              content_type: "product",
              content_id: this.props.product.id,
              content_name: this.props.product.name,
              content_price: this.props.product.price,
              num_items: 1,
            },
          ],
        });
      }
    }
  };
  render() {
    const {
      language,
      settings,
      cart,
      category_id,
      store,
      product,
      isSearch,
      tags,
      usedComponents,
    } = this.props;
    const { isSelected } = this.state;
    if (!product) return <></>;
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";
    const currency =
      language === "english"
        ? settings?.currency_english
        : settings?.currency_local;

    const real_price = getNewPrice(
      product,
      this.props.coupon,
      this.props.discounts,
      this.props.store.smart_promos
    );

    const has_striked_price =
      product.striked_price && product.striked_price > product.price;

    const originalProduct = getOriginalProduct(
      product,
      category_id,
      store.categories
    );

    const outOfStock = isOutOfStock(originalProduct, cart, usedComponents);

    const isDiscounted = product.price > real_price || has_striked_price;

    let itemHeight = 30;
    if (settings.show_nutrition_facts) {
      itemHeight += 60;
    }
    if (
      product.tag &&
      settings.enable_product_tag_staff &&
      settings.enable_product_tag &&
      tags.find((tag) => tag.id === product.tag)
    ) {
      itemHeight += 60;
    }

    const tag = this.props.tags?.find((t) => t.id == this.props.product.tag);
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <Link
        to={{
          pathname:
            (this.props.branch.branch &&
              this.props.settings.is_branch_based_ordering) ||
            !this.props.settings.is_branch_based_ordering ||
            this.props.settings.branch_count === 1 ||
            this.props.product.hide_buy_button ||
            true
              ? `/product/${this.props.product.category}/${this.props.product.slug}`
              : "/select/branch",
          state: {
            pickupOnly: this.props.product.pickup_only,
            deliveryOnly: this.props.product.delivery_only,
          },
        }}
        onClick={() => {
          let store_product = this.props.product;
          if (
            ((this.props.branch.branch ||
              this.props.settings.branch_count === 1) &&
              this.props.settings.is_branch_based_ordering) ||
            !this.props.settings.is_branch_based_ordering ||
            true
          ) {
            if (this.props.category_id !== this.props.product.category_id) {
              try {
                store_product = this.props.store.categories.find(
                  (category) => category.id === this.props.product.category_id
                );
                if (this.props.product.parent) {
                  store_product = store_product.products
                    .find((parent) => parent.id === this.props.product.parent)
                    .children.find(
                      (product) => product.id === this.props.product.id
                    );
                } else {
                  store_product = store_product.products.find(
                    (product) => product.id === this.props.product.id
                  );
                }
              } catch (err) {
                store_product = this.props.product;
              }
            }
            if (this.props.filter_value) this.analytics();

            this.props.setProduct(store_product);
          } else {
            if (this.props.settings.is_branch_based_ordering) {
              if (
                !this.props.branch.branch &&
                this.props.settings.branch_count === 1
              ) {
                return;
              }
              this.props.setNextPage(
                `/product/${this.props.product.category}/${this.props.product.slug}`
              );
            }
          }
        }}
      >
        <ListItem
          className="ml-0 mb-5"
          style={{
            flexDirection: language == "english" ? "row" : "row-reverse",
            borderLeft:
              language != "arabic" && isSelected && `4px solid ${themeColor}`,
            borderRight:
              language == "arabic" && isSelected && `4px solid ${themeColor}`,
            paddingLeft: language != "arabic" && !isSelected && 20,
            paddingRight: language == "arabic" && !isSelected && 20,
          }}
        >
          <div style={{ position: "relative" }}>
            <img
              className="image_menu"
              src={
                this.props.product
                  ? this.props.product.photo_thumb
                    ? this.props.product.photo_thumb
                    : this.props.product.photo
                    ? this.props.product.photo
                    : null
                  : null
              }
              alt="Img"
              style={{
                width: 90,
                minHeight: 90,
                minWidth: 90,
                height: 90,
                borderRadius: 5,
                marginRight: language == "english" ? 15 : 0,
                marginLeft: language == "arabic" ? 15 : 0,
              }}
            />
            {Boolean(isDiscounted) && (
              <div
                className="discount-sign"
                style={{
                  left: language !== "arabic" && 5,
                  right: language === "arabic" && 5,
                  backgroundColor:
                    this.props.discountTagColor || this.props.themeColor,
                  direction: language === "arabic" && "ltr",
                  fontSize: 13,
                }}
              >
                {`${getDiscountedPercentage(
                  real_price,
                  (has_striked_price && product.striked_price) || product.price
                )} %`}
              </div>
            )}
            {this.props.product.preparation_time > 0 &&
              this.props.product.type_of_product !== "service" &&
              this.props.product.show_prep_time &&
              settings.show_prep_times && (
                <div
                  className={`d-flex flex-row  ${
                    this.props.language === "english"
                      ? "prepTimeEnglish"
                      : "prepTimeArabic"
                  } `}
                  style={{
                    direction: this.props.language === "arabic" ? "rtl" : "ltr",

                    background: "rgba(255, 255, 255, 0.9)",
                    borderRadius: "0px 0px 5px 5px",
                    fontWeight: "bold",
                    width: 90,
                    justifyContent: "center",
                    alignItems: "center",
                    height: 30,
                  }}
                >
                  <Clock
                    className="mx-1"
                    style={{
                      width: "15px",
                      height: "15px",
                      fill: this.props.store.settings.dark,
                    }}
                  />
                  <p style={{ fontSize: "12px", color: themeColor }}>
                    {getPrepTime(
                      this.props.product.preparation_time,
                      this.props.language
                    )}
                  </p>
                </div>
              )}
            {this.props.product.duration > 0 &&
              this.props.product.type_of_product === "service" && (
                <div
                  className={`d-flex flex-row  ${
                    this.props.language === "english"
                      ? "prepTimeEnglish"
                      : "prepTimeArabic"
                  } `}
                  style={{
                    direction: this.props.language === "arabic" ? "rtl" : "ltr",

                    background: "rgba(255, 255, 255, 0.9)",
                    borderRadius: "0px 0px 5px 5px",
                    fontWeight: "bold",
                    width: 90,
                    justifyContent: "center",
                    alignItems: "center",
                    height: 30,
                  }}
                >
                  <Clock
                    className="mx-1"
                    style={{
                      width: "15px",
                      height: "15px",
                      fill: this.props.store.settings.dark,
                    }}
                  />
                  <p style={{ fontSize: "12px", color: themeColor }}>
                    {getPrepTime(
                      this.props.product.duration,
                      this.props.language
                    )}
                  </p>
                </div>
              )}
          </div>

          <div className="text-left" style={{ marginRight: 20 }}>
            {product.tag && tag?.placement == "top" && (
              <ProductTag
                product={this.props.product}
                isSearch={isSearch}
                top={true}
              />
            )}
            <h6
              className={
                language == "arabic"
                  ? "text-right layoutProductTitleArabic cut-text-one-line-list"
                  : "layoutProductTitleEnglish cut-text-one-line-list"
              }
              style={{
                fontFamily: "Quicksand, Cairo",
                direction: language == "english" ? "ltr" : "rtl",
                fontWeight: "bold",
                width: "100%",
                right: language === "arabic" && isSelected && 116,
                paddingRight: language !== "arabic" && 3,
                paddingLeft: language === "arabic" && 3,
                position: "relative",
                top: 0,
                right: language === "arabic" && -20,
                textDecoration:
                  this.props.product.not_available && "line-through",
              }}
            >
              {checkForStockWarningMessage(
                this.props.product.show_warning_item_availability,
                this.props.product.inventory_on_hand,
                this.props.product.warning_item_availability_count,
                outOfStock,
                this.props.product.warning_item_availability_message_value,
                language,
                this.props.product.has_variants,
                this.props.product.type_of_product
              )}

              {settings.enable_smart_search &&
              settings.enable_smart_search_staff &&
              this.props.filter_value ? (
                <Highlighter
                  highlightClassName="smart-search-highlight"
                  searchWords={
                    this.props.filter_value
                      ? this.props.filter_value?.split(" ")
                      : ""
                  }
                  autoEscape={true}
                  textToHighlight={
                    language === "english"
                      ? this.props.product.name
                      : this.props.product.ar_name
                  }
                />
              ) : language == "english" ? (
                this.props.product.name
              ) : (
                this.props.product.ar_name
              )}
            </h6>
            {settings.show_nutrition_facts && (
              <div
                className={
                  language == "english"
                    ? "text-left pl-1  mb-3"
                    : "text-right pr-1  mb-3"
                }
              >
                {product.dietary_restrictions?.includes("Dairy free") && (
                  <img
                    src={dairyFreeIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Gluten free") && (
                  <img
                    src={glutenFreeIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Sugar free") && (
                  <img
                    src={sugarFreeIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Nut free") && (
                  <img
                    src={nutFreeIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Vegan") && (
                  <img
                    src={veganIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Vegetarian") && (
                  <img
                    src={vegetarianIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions?.includes("Organic") && (
                  <img
                    src={organicIcon}
                    style={{ marginRight: 5, height: 17, width: 17 }}
                  />
                )}
                {product.dietary_restrictions
                  ?.split(",")
                  .map((r) => r.trim())
                  .includes("Gluten") && (
                  <img
                    src={glutenIcon}
                    style={{ marginRight: 4, height: 18, width: 18 }}
                  />
                )}

                {product.dietary_restrictions?.includes("Nuts/Sesame") && (
                  <img
                    src={nutsSesameIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}

                {product.dietary_restrictions?.includes("Dairy") && (
                  <img
                    src={dairyIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}

                {product.dietary_restrictions?.includes("Egg") && (
                  <img
                    src={eggIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}

                {product.dietary_restrictions?.includes(
                  "Seafood/Shellfish"
                ) && (
                  <img
                    src={seafoodShellfishIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}

                {product.dietary_restrictions?.includes("Chilli") && (
                  <img
                    src={chilliIcon}
                    style={{ marginRight: 4, height: 21, width: 21 }}
                  />
                )}
              </div>
            )}
            {product.tag && tag?.placement == "down" && (
              <ProductTag product={this.props.product} isSearch={isSearch} />
            )}
            <p
              style={{
                top: -5,
                width: "100%",
                position: !product.tag && "relative",
                color: "#333333",
                right: language === "arabic" && isSelected && 116,
                paddingRight: language !== "arabic" && 3,
                paddingLeft: language === "arabic" && 3,
                height: 40,
                right: language === "arabic" && -20,
                textDecoration:
                  this.props.product.not_available && "line-through",
              }}
              className={" cut-text".concat(
                language == "english"
                  ? " layoutProductDescriptionEnglish"
                  : " layoutProductDescriptionArabic text-right"
              )}
            >
              {settings.hide_short_descriptions ? (
                ""
              ) : settings.enable_smart_search && this.props.filter_value ? (
                <Highlighter
                  highlightClassName="smart-search-highlight"
                  searchWords={
                    this.props.filter_value
                      ? this.props.filter_value?.split(" ")
                      : ""
                  }
                  autoEscape={true}
                  textToHighlight={
                    language === "english"
                      ? this.props.product.short_description
                      : this.props.product.ar_short_description
                  }
                />
              ) : language === "english" ? (
                this.props.product.short_description
              ) : (
                this.props.product.ar_short_description
              )}
            </p>

            {!this.props.product.hide_buy_button ? (
              <>
                {this.props.store.settings.show_prices && (
                  <p
                    className={
                      language == "english" ? "priceEnglish" : "priceArabic rtl"
                    }
                    style={{
                      // marginTop:50,
                      color: themeColor,
                      display: "flex",
                      alignItems: "center",
                      position: "absolute",
                      height: itemHeight,
                    }}
                  >
                    {real_price !== this.props.product.price ||
                    has_striked_price ? (
                      <div style={{ position: "relative" }}>
                        <span
                          className={
                            currencyIcon
                          }
                          style={{
                            position: "relative",
                            textDecoration: "line-through",
                            color: themeColor,
                            display:
                              settings.enable_quick_add_to_cart && "flex ",
                            right: settings.enable_quick_add_to_cart && 4,
                            fontSize: settings.enable_quick_add_to_cart && 12,
                            lineHeight: settings.enable_quick_add_to_cart && 1,
                          }}
                        >
                          {has_striked_price
                            ? this.props.product.striked_price.toFixed(
                                settings.currency_decimals
                              )
                            : this.props.product.price.toFixed(
                                settings.currency_decimals
                              )}{" "}
                          {currency}
                        </span>
                        <span
                          style={{ fontWeight: "bold" }}
                          className={
                            currencyIcon
                          }
                        >
                          {real_price.toFixed(settings.currency_decimals)}{" "}
                          {currency}
                        </span>
                      </div>
                    ) : this.props.product.price ? (
                      <span
                        className={
                          currencyIcon
                        }
                        style={{
                          fontWeight: "bold",
                        }}
                      >
                        {this.props.product.price.toFixed(
                          settings.currency_decimals
                        )}{" "}
                        {currency}
                      </span>
                    ) : (
                      <span style={{ fontSize: "14px", fontWeight: "bold" }}>
                        {this.props.language === "arabic"
                          ? "السعر حسب الاختيار "
                          : "Price on selection"}
                      </span>
                    )}
                    {settings.enable_quick_add_to_cart &&
                      !outOfStock &&
                      !this.props.product.not_available &&
                      this.props.product.show_quick_add_to_cart &&
                      !this.props.settings.is_menu && (
                        <div
                          className={
                            (language === "arabic" && "mr-3") || "ml-3"
                          }
                        >
                          <QuickAddToCart
                            isFilter={this.props.isFilter}
                            isSearch={this.props.isSearch}
                            type={"list"}
                            product={originalProduct}
                            key={"add to cart key" + this.props.product.id}
                            setIsSelected={(isSelected) =>
                              this.setState({ isSelected })
                            }
                          />
                        </div>
                      )}
                    {outOfStock && (
                      <div
                        className={(language === "arabic" && "mr-3") || "ml-3"}
                      >
                        <OutOfStock
                          type_of_product={this.props.product.type_of_product}
                        />
                      </div>
                    )}
                    {this.props.product.not_available && !outOfStock && (
                      <div
                        className={(language === "arabic" && "mr-3") || "ml-3"}
                      >
                        <NotAvailable />
                      </div>
                    )}
                  </p>
                )}
              </>
            ) : null}
          </div>
        </ListItem>
      </Link>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    store: state.store.store,
    themeColor: state.store.store.settings.dark,
    discountTagColor: state.store.store.settings.discount_tag_color,
    branch: state.branch,
    settings: state.store.store.settings,
    coupon: state.cart.promos,
    applied_promos: state.cart.smart_promos,
    discounts: state.cart.discounts,
    cart: state.cart.cart,
    tags: state.store.store.tags,
    usedComponents: state.store.used_components,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setProduct: (product) => dispatch(setProduct(product)),
    setNextPage: (nextPage) =>
      dispatch({ type: "SET_NEXT_PAGE", payload: nextPage }),
  };
};
export default connect(mapStateToProps, mapDispatchToProps)(Item);
